enum TYPE_GEOMETRIE {
  POINT = "POINT",
  POLYGON = "POLYGON",
  LINESTRING = "LINESTRING",
}
export default TYPE_GEOMETRIE;
